import PropTypes from "prop-types";
//Styles
import styled from "styled-components";

const AnimatedBackground = styled.div`
  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: ${props =>
    props.theme.components.animatedBackground.backgroundColor};
  background: linear-gradient(
    to right,
    ${props => props.theme.components.animatedBackground.gradientColor[0]} 8%,
    ${props => props.theme.components.animatedBackground.gradientColor[1]} 18%,
    ${props => props.theme.components.animatedBackground.gradientColor[2]} 33%
  );
  background-size: 936px 104px;
  height: ${props => props.height};
  width: ${props => props.width};
  position: relative;
`;

AnimatedBackground.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string
};

export default AnimatedBackground;
